import { create } from 'zustand';

import {
	KubeflexAvailableNetworksInfo,
	KubeflexConfigurationForCreateInfo,
	KvmKubeflexConfigurationInfoShort,
	Sdk_KvmKubernetesFlex_Wide,
} from 'shared/api/contracts';

interface KubeflexStore {
	configuration?: KubeflexConfigurationForCreateInfo;
	setConfiguration: (configuration?: KubeflexConfigurationForCreateInfo) => void;
	availableNetworks?: KubeflexAvailableNetworksInfo;
	setAvailableNetworks: (availableNetworks?: KubeflexAvailableNetworksInfo) => void;
	currentConfig?: KvmKubeflexConfigurationInfoShort;
	setCurrentConfig: (currentConfig?: KvmKubeflexConfigurationInfoShort) => void;
	currentRegion?: string;
	setCurrentRegion: (currentRegion?: string) => void;
	currentNetwork?: KubeflexAvailableNetworksInfo;
	setCurrentNetwork: (currentNetwork?: KubeflexAvailableNetworksInfo) => void;
	currentKubeflex?: Sdk_KvmKubernetesFlex_Wide;
	setCurrentKubeflex: (currentKubeflex?: Sdk_KvmKubernetesFlex_Wide) => void;
}

export const useKubeflexStore = create<KubeflexStore>()(set => ({
	configuration: undefined,
	setConfiguration: configuration => set(() => ({ configuration })),
	availableNetworks: undefined,
	setAvailableNetworks: availableNetworks => set(() => ({ availableNetworks })),
	currentConfig: undefined,
	setCurrentConfig: currentConfig => set(() => ({ currentConfig })),
	currentRegion: undefined,
	setCurrentRegion: currentRegion => set(() => ({ currentRegion })),
	currentNetwork: undefined,
	setCurrentNetwork: currentNetwork => set(() => ({ currentNetwork })),
	currentKubeflex: undefined,
	setCurrentKubeflex: currentKubeflex => set(() => ({ currentKubeflex })),
}));
